if (!customElements.get('media-with-text')) {
  class MediaWithText extends HTMLElement {
    constructor() {
      super();
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            this.animationHandler();
            this.observer.unobserve(this);
          }
        });
      },
      {
        rootMargin: '0px 0px -100px 0px',
      });
      this.observer.observe(this);
    }

    animationHandler() {
      const tl = gsap.timeline({ defaults: { ease: "power3.out" } }),
      mainImageBlock = this.querySelector(".main-media-block"),
      subImageBlock = this.querySelector(".sub-media-block");

      mainImageBlock && tl.from(mainImageBlock, {
        duration: 1.4,
        y: 100,
        opacity: 0,
        clipPath: "inset(0% 0% 0% 100%)",
        ease: "power4.inOut"
      }, "-=0.1");

      subImageBlock && tl.from(subImageBlock, {
        duration: 1.4,
        x: -50,
        opacity: 0,
        clipPath: "inset(0% 100% 0% 0%)",
        ease: "power4.inOut"
      }, "-=1");

      this.addEventListener("mousemove", (e) => {
        const { clientX, clientY } = e;
        const xPos = (clientX / window.innerWidth - 0.5);
        const yPos = (clientY / window.innerHeight - 0.5);

        mainImageBlock && gsap.to(mainImageBlock, {
          x: xPos * 20,
          y: yPos * 20,
          duration: 1,
          ease: "power2.out"
        });

        subImageBlock && gsap.to(subImageBlock, {
          x: -xPos * 30,
          y: -yPos * 30,
          duration: 1,
          ease: "power2.out"
        });
      });
    }
  }
  customElements.define('media-with-text', MediaWithText);
}